<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
        <form
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div style="border-bottom: 1px grey solid;" class="form-group m-form__group confirm-row">
            <label style="font-size: 30px;"> Are you sure? </label>
          </div>
          <div class="form-group m-form__group confirm-row">
            <label style="text-align: left;">By typing 'charge subscribers' and clicking 'Confirm', you will charge {{ numberOfSubscribers }} subscribers for a total of {{ totalChargeAmount | currency }}.</label>
          </div>

          <div style="border-bottom: 1px grey solid;" class="form-group m-form__group row confirm-row">
            <input [(ngModel)]="confirmInput" name="confirmInput" type="text" placeholder="charge subscribers"/>
          </div>
  
          <div style="display: flex; justify-content: space-between; margin-top: 20px;">
            <button
              [disabled]="!ready"
              [debounceClick]
              (click)="saveAndClose(true)"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Confirm {{ countdown > 0 ? '(' + countdown + ')' : '' }}
            </button>
            <button
              (click)="saveAndClose(false)"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>